export default function Hero() {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 pt-24 pb-16">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="relative max-w-7xl mx-auto px-8 h-full flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center w-full">
          <div className="lg:col-span-2 space-y-8">
            <div className="space-y-4">
              <h1 className="text-6xl font-bold leading-tight" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <span className="block text-gray-900">あなたの想いを</span>
                <span className="block text-7xl italic text-rose-600" style={{ fontFamily: "'Noto Serif JP', serif" }}>絵で表現する</span>
                <span className="block text-gray-900">クリエイティブパートナー</span>
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                企業のブランディングから個人のストーリーまで、<br />
                あらゆる「伝えたい想い」を視覚的に表現します。<br />
                15年以上の実績と、200社を超えるクライアントとの信頼関係が、<br />
                私たちの品質を証明しています。
              </p>
            </div>
            
            <div className="flex gap-4">
              <a href="#portfolio" className="px-8 py-4 bg-gray-900 text-white text-base font-medium rounded-lg hover:bg-gray-800 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer">
                作品を見る
              </a>
              <a href="#contact" className="px-8 py-4 border-2 border-gray-900 text-gray-900 text-base font-medium rounded-lg hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                相談する
              </a>
            </div>
          </div>
          
          <div className="lg:col-span-3">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20illustrator%20workspace%20with%20artistic%20tools%2C%20watercolor%20paintings%2C%20digital%20tablet%2C%20warm%20natural%20lighting%2C%20creative%20atmosphere%2C%20minimalist%20aesthetic%2C%20soft%20pastel%20colors%2C%20artistic%20composition%2C%20high%20quality%20photography%2C%20clean%20and%20organized%20studio%20environment&width=900&height=700&seq=hero001&orientation=landscape"
                alt="イラストレーション制作風景"
                className="w-full h-[600px] object-cover rounded-3xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-rose-100 rounded-full flex items-center justify-center">
                    <i className="ri-award-line text-3xl text-rose-600"></i>
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-gray-900">200+</p>
                    <p className="text-sm text-gray-600">プロジェクト実績</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}